import { ContractorForm } from "./ContractorForm";
import { getFullPath, routes } from "../routes";
import { Navigate, useParams } from "react-router";
import { useContractor } from "./hooks";

export function EditContractor() {
  const { id } = useParams();
  const { data, isLoading, isError } = useContractor(id);

  if (isLoading) {
    return <p>Loading...</p>;
  } else if (isError) {
    return <p>An unknown error occurred.</p>;
  } else if (data) {
    return <ContractorForm data={data} />;
  } else {
    return <Navigate to={getFullPath(routes.contractor.create)} />;
  }
}
